// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tJb3","col":"styles_col__Ooah3"};